import { useMutation, type UseMutationResult } from '@tanstack/react-query'
import { queryClient } from 'src'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'
import type { PortInfoType } from '~pages/pages-behind-login/port-info-page/types'

export interface PostPortInfoPayload {
  type: PortInfoType
  vesselName: string
  imoNumber: string
  pool: string
}

export interface PostPortInfoResponse {
  acknowledged: boolean
  insertedId: string
}

export function usePostPortInfo(): UseMutationResult<
  PostPortInfoResponse,
  unknown,
  PostPortInfoPayload
> {
  const fetchRequest = useFetch()

  return useMutation<PostPortInfoResponse, unknown, PostPortInfoPayload>({
    mutationFn: async (payload: PostPortInfoPayload) => {
      const response = await fetchRequest(
        `${apiBase()}/portinfo`,
        undefined,
        payload,
        'POST',
      )
      return response as PostPortInfoResponse
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['/portinfo'],
      })
    },
  })
}
